import React from 'react';
import PaginationTable from '../PaginationTable';

export default class ClientsList extends React.Component {

    constructor(props) {
        super(props);
        this.pageChange = this.pageChange.bind(this);
    }

    componentWillMount() {
        this.props.fetchClients();
    }

    pageChange(page) {
        this.props.fetchClients(page);
    }

    render() { 
        return (
            <div>
                <PaginationTable {...this.props.clientsState.data} pageChange={this.pageChange} headerComponent={renderHeader} rowComponent={renderRow}/>
            </div>
        );
    }
}

function renderHeader(props) {
    return (
        <tr>
            <th>
                Nombre
            </th>
            <th>
                SIC
            </th>
            <th>
                Tel. Casa
            </th>
            <th>
                Tel. Oficina
            </th>
            <th>
                Tel. Otro
            </th>
            <th>
                Correo 1
            </th>
            <th>
                Correo 2
            </th>
            <th>

            </th>
        </tr>
    );
}

function renderRow(props) {
    const client = props.item;
    return (
        <tr>
            <td>
                {client.name} {client.apellido_paterno} {client.apellido_materno}
            </td>
            <td>
                SIC
            </td>
            <td>
                {client.tel_casa}
            </td>
            <td>
                {client.tel_oficina}
            </td>
            <td>
                {client.tel_otro}
            </td>
            <td>
                {client.correo1}
            </td>
            <td>
                {client.correo2}
            </td>
            <td>

            </td>
        </tr>
    );    
}


/** WEBPACK FOOTER **
 ** ./src/components/presentation/clients/ClientsList.jsx
 **/